import { render, staticRenderFns } from "./responsiveamazingOffers.vue?vue&type=template&id=58ec1381&scoped=true&"
import script from "./responsiveamazingOffers.vue?vue&type=script&lang=js&"
export * from "./responsiveamazingOffers.vue?vue&type=script&lang=js&"
import style0 from "./responsiveamazingOffers.vue?vue&type=style&index=0&id=58ec1381&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58ec1381",
  null
  
)

export default component.exports